var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786,
    height: 454,
    viewBox: "0 0 786 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.59 251.215L329.589 278.889L442.88 213.162L393.153 185.488L281.59 251.215Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.59 397.365L329.589 425.039L442.88 359.317L393.153 331.644L281.59 397.365Z",
    stroke: "#231F20",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.863 397.365L329.862 425.039L443.148 359.317L393.426 331.644L281.863 397.365Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M329.59 278.889V425.038",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.719 185.488V331.643L442.829 359.265V213.115",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M281.59 250.734V396.884",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.59 329.744L329.589 357.418L442.88 291.691L393.153 264.018L281.59 329.744Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.863 397.365L329.862 425.039L443.148 359.317L393.426 331.644L281.863 397.365Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.59 357.418V425.044",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M281.59 329.264V398.639",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M328.98 357.501L376.979 385.175L490.271 319.448L440.543 291.774L328.98 357.501Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M329.254 425.122L377.253 452.796L490.539 387.074L440.817 359.4L329.254 425.122Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M376.98 385.175V452.796",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M489.355 318.832V386.453",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M328.98 357.021V426.395",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.086 249.912L177.092 277.591L63.8008 211.864L113.528 184.19L225.086 249.912Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.086 396.068L177.092 423.741L63.8008 358.014L113.528 330.341L225.086 396.068Z",
    stroke: "#231F20",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.818 396.068L176.819 423.741L63.5273 358.014L113.255 330.341L224.818 396.068Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.094 277.591V423.74",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.958 184.19V330.34L63.8477 357.967V211.817",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M225.086 249.437V395.586",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.75 3.75"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2 250.537L49.999 278.211L163.29 212.484L113.563 184.811L2 250.537Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2 396.688L49.999 424.366L163.29 358.639L113.563 330.966L2 396.688Z",
    stroke: "#231F20",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27344 396.688L50.2724 424.366L163.558 358.639L113.836 330.966L2.27344 396.688Z",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50 278.211V424.366",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.129 184.811V330.965L163.239 358.592V212.437",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2 250.057V396.211",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M569 1V414",
    stroke: "white",
    strokeWidth: 1.08148,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M612 0V414",
    stroke: "white",
    strokeWidth: 1.08148,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M653 0V414",
    stroke: "white",
    strokeWidth: 1.08009,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M692 0V414",
    stroke: "white",
    strokeWidth: 1.08243,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M734 1V414",
    stroke: "white",
    strokeWidth: 1.08148,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M773 0V414",
    stroke: "white",
    strokeWidth: 1.08148,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M568.995 381.884C575.577 381.884 580.912 376.548 580.912 369.967C580.912 363.385 575.577 358.05 568.995 358.05C562.414 358.05 557.078 363.385 557.078 369.967C557.078 376.548 562.414 381.884 568.995 381.884Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M610.964 339.235C617.545 339.235 622.881 333.9 622.881 327.318C622.881 320.737 617.545 315.401 610.964 315.401C604.382 315.401 599.047 320.737 599.047 327.318C599.047 333.9 604.382 339.235 610.964 339.235Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M652.94 224.148C659.522 224.148 664.857 218.813 664.857 212.231C664.857 205.65 659.522 200.314 652.94 200.314C646.359 200.314 641.023 205.65 641.023 212.231C641.023 218.813 646.359 224.148 652.94 224.148Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M734.179 268.824C740.76 268.824 746.096 263.489 746.096 256.907C746.096 250.326 740.76 244.99 734.179 244.99C727.597 244.99 722.262 250.326 722.262 256.907C722.262 263.489 727.597 268.824 734.179 268.824Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M691.526 248.519C698.108 248.519 703.443 243.184 703.443 236.602C703.443 230.021 698.108 224.686 691.526 224.686C684.945 224.686 679.609 230.021 679.609 236.602C679.609 243.184 684.945 248.519 691.526 248.519Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M773.44 327.722C780.022 327.722 785.357 322.386 785.357 315.805C785.357 309.223 780.022 303.888 773.44 303.888C766.859 303.888 761.523 309.223 761.523 315.805C761.523 322.386 766.859 327.722 773.44 327.722Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M568.996 369.966L610.967 327.317L652.943 212.23L734.514 260.297L773.442 315.804",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M568.996 260.297L610.967 217.643L651.923 160.438L734.514 186.844L773.442 206.135",
    stroke: "white",
    strokeWidth: 1.35573,
    strokeMiterlimit: 10,
    strokeDasharray: "3.1 3.1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M568.995 272.214C575.577 272.214 580.912 266.878 580.912 260.297C580.912 253.715 575.577 248.38 568.995 248.38C562.414 248.38 557.078 253.715 557.078 260.297C557.078 266.878 562.414 272.214 568.995 272.214Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.677864,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M610.964 229.561C617.545 229.561 622.881 224.226 622.881 217.644C622.881 211.063 617.545 205.728 610.964 205.728C604.382 205.728 599.047 211.063 599.047 217.644C599.047 224.226 604.382 229.561 610.964 229.561Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.677864,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M651.925 172.355C658.506 172.355 663.842 167.02 663.842 160.438C663.842 153.857 658.506 148.521 651.925 148.521C645.343 148.521 640.008 153.857 640.008 160.438C640.008 167.02 645.343 172.355 651.925 172.355Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.677864,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M734.511 198.762C741.092 198.762 746.428 193.426 746.428 186.845C746.428 180.263 741.092 174.928 734.511 174.928C727.929 174.928 722.594 180.263 722.594 186.845C722.594 193.426 727.929 198.762 734.511 198.762Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.677864,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M691.186 186.575C697.768 186.575 703.103 181.24 703.103 174.658C703.103 168.077 697.768 162.741 691.186 162.741C684.605 162.741 679.27 168.077 679.27 174.658C679.27 181.24 684.605 186.575 691.186 186.575Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.677864,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M773.44 218.053C780.022 218.053 785.357 212.717 785.357 206.136C785.357 199.554 780.022 194.219 773.44 194.219C766.859 194.219 761.523 199.554 761.523 206.136C761.523 212.717 766.859 218.053 773.44 218.053Z",
    fill: "#6C3A50",
    stroke: "white",
    strokeWidth: 0.677864,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.c21d95bc93669085a1f427b2a14ed85c.svg";
export { ForwardRef as ReactComponent };